// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"kJ","blender_bottle_img":"lJ","blender_bottle_info":"mJ","blender_bottle_title":"nJ","blender_bottle_bold":"oJ","blender_bottle_usual":"pJ","blender_bottle_item_mob":"qJ","addbutton":"rJ","blender_bottle_title_mob":"sJ","blender_bottle_bold_mob":"tJ","blender_bottle_usual_mob":"uJ","bolder":"vJ","bottom_margin_4":"wJ","bottom_margin_16":"xJ"};
    if(module.hot) {
      // 1721922364729
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  